export const TRADEMARK_WATCH_REPORT = {
  headline: '2 marks look similar to ours',
  status: 'attention',
  durationSec: 221,
  body: `**This week’s journal has 2 marks similar to our watchlist.** I downloaded 4 PDFs (68 MB) from IP-India and checked 6,412 newly advertised marks in classes 9, 35 and 42.

| Mark | App. no. | Class | Applicant | Similar to | Risk |
|---|---|---|---|---|---|
| DATAOBSERV | 6612907 | 42 | Observ Analytics Pvt Ltd | DataObserve | **High** — one letter dropped, same class |
| DO-SENSE AI | 6598114 | 9 | Sensewise Technologies LLP | DO Sense | Medium — adds “AI”, related goods |

No similar marks for **DO Chat**.

**Opposition window:** four months from the date of advertisement, for both marks.

**Next step:** share this with counsel. I can draft a notice of opposition (Form TM-O) for DATAOBSERV if you want to proceed.

*Screening only — not legal advice.*`,
}
